<template>
  <div v-if="alerts.length" class="time-notification-stack" aria-live="assertive">
    <article v-for="alert in alerts" :key="alert.id" class="time-notification" :class="`is-${alert.alert_type}`">
      <header>
        <div>
          <small>{{ alert.ticket_label }}</small>
          <strong>{{ alert.title }}</strong>
        </div>
        <button type="button" class="close-button" title="Cerrar" @click="acknowledge(alert, 'dismiss')">×</button>
      </header>
      <p>{{ alert.message }}</p>
      <footer>
        <button type="button" class="notice-button" @click="$emit('open-ticket', alert)">Abrir cuenta</button>
        <button v-if="alert.alert_type === 'warning'" type="button" class="notice-button primary" @click="acknowledge(alert, 'snooze')">Avísame en 5 min</button>
        <button v-if="alert.alert_type === 'pending_start'" type="button" class="notice-button" @click="acknowledge(alert, 'dismiss')">No</button>
        <button v-if="alert.alert_type === 'pending_start'" type="button" class="notice-button primary" @click="acknowledge(alert, 'start')">Sí, iniciar</button>
        <button v-if="alert.alert_type === 'finished'" type="button" class="notice-button primary" @click="acknowledge(alert, 'dismiss')">Entendido</button>
      </footer>
    </article>
  </div>
</template>

<script>
export default {
  name: 'PosTimeNotifications',
  props: {
    alerts: { type: Array, default: () => [] },
  },
  emits: ['acknowledge', 'open-ticket'],
  methods: {
    acknowledge(alert, action) {
      this.$emit('acknowledge', { alert, action });
    },
  },
};
</script>

<style scoped>
.time-notification-stack {
  position: fixed;
  top: 5.35rem;
  left: 1rem;
  z-index: 1700;
  display: grid;
  gap: .8rem;
  width: min(28rem, calc(100vw - 2rem));
  pointer-events: none;
}
.time-notification {
  pointer-events: auto;
  padding: 1rem;
  border: 1px solid rgba(255, 255, 255, .24);
  border-radius: 24px;
  background:
    radial-gradient(circle at 8% 0%, rgba(244, 162, 97, .28), transparent 11rem),
    linear-gradient(145deg, rgba(19, 31, 51, .98), rgba(9, 18, 32, .96));
  color: #fff;
  box-shadow: 0 24px 80px rgba(10, 18, 32, .38);
  backdrop-filter: blur(18px);
  animation: notice-in .2s ease-out;
}
.time-notification.is-finished { border-color: rgba(255, 111, 97, .55); }
.time-notification.is-warning { border-color: rgba(255, 209, 102, .5); }
.time-notification header { display: flex; justify-content: space-between; align-items: flex-start; gap: .8rem; }
.time-notification header small { display: block; color: rgba(255, 255, 255, .66); font-weight: 800; }
.time-notification header strong { display: block; margin-top: .18rem; font-size: 1.16rem; }
.time-notification p { margin: .8rem 0 1rem; color: rgba(255, 255, 255, .82); font-weight: 700; line-height: 1.45; }
.close-button {
  flex: 0 0 auto;
  width: 2.35rem;
  height: 2.35rem;
  border: 0;
  border-radius: 999px;
  background: rgba(255, 255, 255, .12);
  color: #fff;
  font-size: 1.2rem;
  cursor: pointer;
}
.time-notification footer { display: flex; flex-wrap: wrap; gap: .5rem; }
.notice-button {
  flex: 1;
  min-width: 7.5rem;
  padding: .68rem .8rem;
  border: 1px solid rgba(255, 255, 255, .18);
  border-radius: 999px;
  background: rgba(255, 255, 255, .1);
  color: #fff;
  font-weight: 900;
  cursor: pointer;
}
.notice-button.primary { background: #f4a261; border-color: #f4a261; color: #14213d; }
@keyframes notice-in {
  from { opacity: 0; transform: translateY(-8px) scale(.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}
@media (max-width: 720px) {
  .time-notification-stack { top: 8.4rem; }
}
</style>
